import React from 'react'
import styled from 'styled-components/macro'

const HorizontalCenterWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export {HorizontalCenterWrapper};